import * as Resources from '../util/resources';


export function readPayouts(businessID) {
  return async function(dispatch) {
    await dispatch(Resources.readResources({
      url:                `${API_URL}/business/${businessID}/payouts`,
      resourceType:       'payouts',
      list:               businessID,
      requestKey:         `read-${businessID}`,
      showDefaultErrorUI: false,
      transformData:      data => [{ id: businessID, ...data }]
    }));
  };
}
